import React from 'react'; 
import { Row, Col, Tabs  } from 'antd';
import { LoadingComponent } from '../../utils/ui'
import WikiProxy from './WikiProxy';
import DLMProxy from './FileSelectProxy';
import AssetProxy from './AssetProxy';
import ElementProxy from './ElementProxy';


const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

const makeTitle = linker => {
  if (linker && linker.o){
    if (linker.label) return linker.label + " (IRI - "+decodeURI(linker.o)+")";
    return decodeURI(linker.o);
  }
  return "";
}
/** Карточка актива. Отображаются данные из vasset.
 * обеспечивает загрузку данных по ассету, так как дочерние компоненты должны используать уже загруженные данные.
 * Так же контролирует отображение в режимах редактирования и перевода.
 * 
 * 20200530 см. https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
 * перевод для асинхронного вызова загрузки карточки 
 */
class LinkerCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: true, 			  //Флаг загрузки, карточки ADMS
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      views: false,         //Загружены представления содержимого актива
    }
  }
   
  static getDerivedStateFromProps(props, state) {
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    e.preventDefault();
  }

  render() {
    let { loaded } = this.state;
    console.log(this);
    if (!loaded) return <LoadingComponent />;
    return (
      <span>
        <Row>
          <Col span={24}><strong>Выбранный элемент:{'\u00A0'}</strong>{makeTitle(this.props.linker)}</Col>
        </Row>
        <Row>
          <Tabs onChange={callback} type="card">
            <TabPane tab="Wiki" key="1">
              <WikiProxy {...this.props} /> 
            </TabPane>
            <TabPane tab="Документы" key="2">
              <DLMProxy {...this.props} />
            </TabPane>
            <TabPane tab="Модели" key="3">
              <AssetProxy {...this.props} />
            </TabPane>
            <TabPane tab="Элементы моделей" key="4">
              <ElementProxy {...this.props} />
            </TabPane>
          </Tabs>
        </Row>
      </span>
    )
  }
}


export default LinkerCard;